import type { Styles } from '@chakra-ui/theme-tools'

const styles: Styles = {
  global: () => ({
    'a': {
      color: 'primary.600',
      cursor: 'pointer',
      textDecoration: 'underline',
      outline: 'none',
      letterSpacing: '0.15px',
      fontWeight: 'medium',
      fontStyle: 'normal',
      fontSize: '16px',
      _hover: { color: 'primary.700' }
    },
    // using https://github.com/WICG/focus-visible breaks <select> in theme
    // :not(.focus-visible)
    ':focus': {
      outline: 'none'
    }
  })
}

export default styles
